import React from "react";
export var DividedContainer = function DividedContainer(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex cb-divided-container align-items-center cb-menu-detail__content ".concat(className || "")
  }, children);
};